import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
import messages from './messages'
import WhiteSpace from 'components/WhiteSpace'
import { Button, Drawer, Icon, Spin, Form } from 'antd'
import { intl, recordCountlyEvent, handleAmount } from 'utils'
import { Flex } from 'antd-mobile'
import _ from 'lodash'

const IMAGES = {
  AliPay: require('./images/AliPay+.png'),
  AliPaySm: require('./images/AliPaySmall.png')
}

const ICONS = {
  AliPay: require('./images/AliPayIcon.svg'),
}

class AliPay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCalledDeeplink: false,
    }
  }

  handleSubmit = () => {
    const { submit, pageName, siteConfig, ...data } = this.props
    console.log(data, 'data-100')
    pageName &&
      recordCountlyEvent({
        page_name: pageName,
        event_name: 'pull',
        element_name: 'pull_pay',
        biz_tags: {
          channel: data.tabName.toLowerCase().replace(' ', '_'),
          trade_voucher_no: sessionStorage.orderNo,
        },
      })
    setTimeout(() => {
      this.setState({ isCalledDeeplink: true })
    }, 1000)
    submit({
      ...data,
      method: 'PAY_WITH_WALLET',
    })
  }

  render() {
    const {
      siteConfig,
      hostApp,
      introduceMediaUrl,
      optAppItems = [],
      loading,
      pageName,
    } = this.props
    console.log(this.props, 'this.props-1')
    const { isCalledDeeplink } = this.state
    if (siteConfig.isMobile) {
      return (
        <div className={classes.componentsPaymentMethodsApp}>
          {!isCalledDeeplink && (
            <Button
              block
              loading={isCalledDeeplink}
              type='default'
              size='large'
              style={{ borderColor: 'var(--gray-7)', backgroundColor: 'var(--gray-1)' }}
              onClick={this.handleSubmit}
            >
              <img src={ICONS[this.props.tabName]} alt={`Icon for ${this.props.tabName}`} />
            </Button>
          )}
          <Drawer
            visible={isCalledDeeplink}
            height='300px'
            className={classes.calledDeepLinkDrawer}
            closable={false}
            placement='bottom'
          >
            <Flex direction='column' className='h-full'>
              <Flex.Item>
                <div>
                  <Flex direction='column' justify='center' className='text-center'>
                    <div className={classes.circleShadow}>
                      <Spin
                        spinning={isCalledDeeplink}
                        className={classes.spin}
                        indicator={
                          <Icon type='loading' style={{ fontSize: 60 }} spin />
                        }
                      />
                    </div>
                    <WhiteSpace size='xl' />
                    {intl().formatMessage(messages.Processing)}
                    <WhiteSpace size='sm' />
                    <div className='paragraph_regular text_secondary'>
                      {`${intl().formatMessage(messages.ProcessingDescription)}`}&nbsp;*
                      <i className='text_main paragraph_regular'>
                        {intl().formatMessage(messages.HighlightAliPayName)}
                      </i>
                      *
                    </div>
                  </Flex>
                </div>
                <WhiteSpace size='xl' />
                <WhiteSpace size='sm' />
              </Flex.Item>
              <div className='w-full'>
                <Button
                  block
                  type='primary'
                  size='large'
                  onClick={() => {
                    pageName &&
                      recordCountlyEvent({
                        page_name: pageName,
                        event_name: 'click',
                        element_name: 'retry',
                        biz_tags: {
                          trade_voucher_no: sessionStorage.orderNo,
                        },
                      })
                    this.setState({ isCalledDeeplink: false })
                  }}
                >
                  <span>{intl().formatMessage(messages.BacktoRetry)}</span>
                </Button>
              </div>
            </Flex>
          </Drawer>
          {!siteConfig.isMobile && <WhiteSpace size='xl' />}
          {optAppItems.indexOf('introduceMedia') > -1 && introduceMediaUrl && (
            <video className={classes.vedio} autoPlay muted loop playsInline>
              <source src={introduceMediaUrl} type='video/mp4' />
            </video>
          )}
          {!siteConfig.isMobile && <WhiteSpace />}
        </div>
      )
    }
    return (
      <div className={classes.componentsPaymentMethodsApp}>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <img src={IMAGES.AliPay} alt={`Icon for ${this.props.tabName}`} />
        <WhiteSpace size='xl' />
        <div className='text_secondary font-13'>
          {intl().formatMessage(messages.RedirectedTo)}
        </div>
        <WhiteSpace size='sm' />
        <img src={IMAGES.AliPaySm} alt={`Icon for ${hostApp}`} />
        <span className='text_secondary font-13'>
          {intl().formatMessage(messages.CashierPage)}
        </span>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <Form.Item>
          <Button
            loading={loading}
            block
            size='large'
            type='primary'
            onClick={this.handleSubmit}
          >
            {intl().formatMessage(messages.Pay)} {_.get(siteConfig, 'payInfo.payAmount') && handleAmount(siteConfig.payInfo.payAmount)}
          </Button>
        </Form.Item>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(AliPay)
